<!--签章组件-->
<!--注意：固定签章不可移动，不可删除-->
<template>
  <div onpaste="return false" :class="{'signature-wrap':true,'fixed':!!itemInfo.chapteFixed}"
       :style="handleSetChapte"
       ref="move-box" :key="loopkey" tabindex="0" v-loading="imgLoading">
    <!--签章图片方式展示-->
    <!--自定义签章样式展示-->
    <el-popover
      placement="right"
      width="200"
      trigger="manual"
      v-model="setPupVisi"
    >
      <!-- 变量设置弹窗 -->
      <div>
        <h1>设置变量
          <i class="el-icon-error close-sty" @click="setPupVisi = false"></i>
        </h1>
        <p class="var-setting">印章名称</p>
          <el-input
            type="text"
            resize="none"
            maxlength="20"
            size="mini"
            placeholder="填写印章名称"
            :row="2"
            :value="itemInfo.signerAbc"
            :disabled="itemInfo.copy"
            @input="changeInputId"
          />
          <p class="btns-sty" v-show="!itemInfo.copy">
            <a class="btn" @click="copyShowSetting">复制</a>
            <a class="btn" @click="changeShowSetting(false)">确定</a>
          </p>
      </div>
      <div 
        slot="reference" 
        :class="[
          {'qz-new':true,'draging':!!cachetMove},
          itemInfo.varType === flag.SIGN ? 'person-chap' : (itemInfo.varType === flag.SIGNNATURE ? 'ent-chap' : 'defalut-chap')
        ]"
        @click="showSetHand(itemInfo)"
        @mousedown.capture="handleCacheMousedown($event)"
      >
        <a v-if="!itemInfo.chapteFixed && !imgLoading"  @click="delItemInfo" href="javascript:void (0)" class="el-icon-error del-chapter"></a>
        <div :class="{'copy-sty':itemInfo.copy}">
          <h1 :style="{background:[undefined,null].includes(itemInfo.batch) ? '#ffa7a7':'#e6cc75'}">{{itemInfo.signerAbc}}</h1>
          <div class="con" :style="{borderColor:[undefined,null].includes(itemInfo.batch) ? '#ffa7a7':'#e6cc75'}">
            {{itemInfo.qsInfo | eclipse}}
          </div>
          <img v-if="!itemInfo.chapteFixed" src='../../assets/images/move-icon.png'/>
          <span class="time" :style="{color:[undefined,null].includes(itemInfo.batch) ? '#ffa7a7':'#e6cc75'}">日期：XXXX</span>
          <el-button
            v-if="!($route.query.apiPdf)"
            plain 
            type="primary" 
            size="mini" 
            class="batch-settings"
            @click.stop="VISI = true"
          >批量设置</el-button>
        </div>
      </div>
    </el-popover>
    <BatchSettingsPup 
      title="印章批量设置"
      :visible.sync="VISI"
      width="40%"
      :appendToBody="true"
      :VISI="VISI"
      :items="items"
      :BChapCurr="itemInfo"
      :before-close="(done)=>{VISI =false;done()}"
      @BatchSettinsClose="BSClose"
    ></BatchSettingsPup>
  </div>
</template>
<script>
  import flagType from './flagType';
  import BatchSettingsPup from '../../components/contract-view/components/BatchSettingsPup.vue'

  export default {
    name: 'signatureComponent',
    components:{BatchSettingsPup},
    props: {
      // 循环时的key
      loopkey: {
        type: [String, Number],
        default: '',
      },
      itemInfo: {
        type: Object,
        default() {
          return {};
        },
      },
      // 总页数
      items: { type: Number, default: 0 },
      // 定位的父级容器id
      relativeNodeId: {
        type: String,
        default: '',
      },
      // 缩放比例
      scaleValue: {type: Number, default: 100},
    },
    data() {
      return {
        setPupVisi:false,// 变量设置弹窗
        VISI:false,
        flagType,
        flag: flagType.flag,
        cachetMove: false,
        // 当前用户选中拖拽的章的dom对象
        objCurrentCachet: null,
        imgLoading: false,
      };
    },
    filters: {
      eclipse(value) {
        if (!value) return '';
        let maxNum = 23;
        value = value + '';
        return value.length > maxNum ? value.substr(0, maxNum) + '...' : value;
      },
    },
    computed: {
      // 计算当前章在页面中的位置
      handleSetChapte() {
        let {realWidth: parentWidth, realHeight: ParentHeight} = this.getParentInfo();
        let {offsetX, offsetY} = this.itemInfo; // 根据组件在合同中左下角位置比例信息换算出left ，top值
        let caechetH = this.itemInfo.h * ParentHeight;
        return {
          left: parseFloat((offsetX * parentWidth).toFixed(4)) + 'px',
          top: parseFloat((offsetY * ParentHeight - caechetH).toFixed(4)) + 'px', // 保存的时左下角的点位置，显示时计算top值需要减去本身高度
        };
      },
      // 根据组件类型返回对应信息
      getFlagInfo() {
        return this.flagType.getFlagOption(this.itemInfo.varType);
      },
    },
    mounted() {
    },
    methods: {
      // 控制显示设置弹窗
      showSetHand(chap){
        if(!chap.copy){
          this.setPupVisi=!this.setPupVisi
        }
      },
      // 输入框对应的设置弹窗显示更改
      changeShowSetting(val) {
        this.$emit("changeItemInfo", { ...this.itemInfo, showSetting: !!val });
        this.setPupVisi = val;
      },
      /** 设置窗口复制按钮功能 */
      copyShowSetting(){
        this.$emit("quoteCopy", { ...this.itemInfo, showSetting: false});
      },
      /** 变量名称改变 */
      changeInputId(val){
        this.$emit("changeItemInfo", { ...this.itemInfo, signerAbc: val });
      },
      BSClose(param){
        if(param.status === 'submit'){
          this.$emit('BatchSettinsClose',{...param,CUR:{...this.itemInfo}});
        }
        this.VISI = false;
      },
      handleImgLoad() {
        this.imgLoading = false;
      },
      // 相对父级定位-获取定位父级（设置position:relative;的父级）信息
      getParentInfo() {
        let parentNode = document.getElementById(this.relativeNodeId);
        let RectInfo = parentNode.getBoundingClientRect(); // 注意，使用getBoundingClientRect返回时若页面缩放，则返回的是缩放后的值
        RectInfo.realWidth = this.scaleToShow(RectInfo.width); // 真实宽
        RectInfo.realHeight = this.scaleToShow(RectInfo.height); // 真实高
        return RectInfo;
      },
      // 删除当前项
      delItemInfo() {
        this.$emit('delItemInfo', this.itemInfo);
      },
      // 页面缩放后的值重新计算为页面真正的值
      scaleToShow(val) {
        return parseFloat(val) / (this.scaleValue / 100);
      },
      // 页面缩放-真实值计算为缩放后的值
      scaleToVal(val) {
        return parseFloat(val) * (this.scaleValue / 100);
      },
      // 签章停止事件
      handleCacheStop: function(el) {
        // if (this.chapteFixed) return
        el.preventDefault();
        this.doCachetStop(el);
      },
      // 签章鼠标按下事件
      handleCacheMousedown: function(el) {
        if (this.itemInfo.chapteFixed) return;
        el.preventDefault();
        this.doCachetStart();
        this.objCurrentCachet = el.target; // 获取move dom
        if (!this.objCurrentCachet) return;
        document.addEventListener('mousemove', this.handleCacheMousemove, false);
        document.addEventListener('mouseup', this.handleCacheStop, false);
      },
      // 签章随着鼠标移动事件--统一使用缩放值计算
      handleCacheMousemove: function(el) {
        // if (this.chapteFixed) return
        el.preventDefault();
        if (!this.cachetMove && !this.objCurrentCachet) return;
        let moveDom = this.$refs['move-box'];
        let {top: contBoxTop, left: contBoxLeft, width: contBoxW, height: contBoxH} = this.getParentInfo();
        let {pageX: mouseX, pageY: mouseY} = el;
        let {width: caechetW, height: caechetH} = moveDom.getBoundingClientRect();
        let top = mouseY - contBoxTop - caechetH / 2;
        let left = mouseX - contBoxLeft - caechetW / 2;

        // 处理边界情况
        let boundaryValue = this.scaleToVal(35); // 合同的最小边界值
        if (top < boundaryValue) {
          top = boundaryValue;
        } else if (top > (contBoxH - caechetH - boundaryValue)) {
          top = contBoxH - caechetH - boundaryValue;
        }

        if (left < boundaryValue) {
          left = boundaryValue;
        } else if (left > (contBoxW - caechetW - boundaryValue)) {
          left = contBoxW - caechetW - boundaryValue;
        }

        // 加入缩放因子
        // console.log('加入缩放因子前的值',left,top)
        left = this.scaleToShow(left);
        top = this.scaleToShow(top);
        // console.log('加入缩放因子后的值',left,top)
        moveDom.style.top = `${top}px`;
        moveDom.style.left = `${left}px`;
      },
      doCachetStop: function () {
        this.cachetMove = false;
        document.removeEventListener('mousemove', this.handleCacheMousemove, false);
        document.removeEventListener('mouseup', this.handleCacheStop, false);
        if (this.objCurrentCachet) {
          let moveDom = this.$refs['move-box'];
          let {realWidth: contBoxW, realHeight: contBoxH} = this.getParentInfo();
          let y = 0,newH = null;
          if (moveDom) {
            y = moveDom.clientHeight;  // 用 DOM 实际高度
            // 用 DOM 实际高度（真实坐标系）
            // 注意：getBoundingClientRect 含 scale，clientHeight 不含 scale
            // contBoxH 是 scaleToShow 后的真实高度，所以这里也要用真实高度
            let realHeight = this.scaleToShow(moveDom.getBoundingClientRect().height);
            // 反推正确的 h
            newH = parseFloat((realHeight / contBoxH).toFixed(4));
          }
          // 印章对象
          const chapt ={
            ...this.itemInfo,
            'offsetX': parseFloat((parseInt(moveDom.style.left) / contBoxW).toFixed(4)),
            'offsetY': parseFloat(((parseInt(moveDom.style.top) + y) / contBoxH).toFixed(4)),
          };
          if(newH){ chapt.h = newH};
          this.$emit('changeItemInfo', chapt);
          this.objCurrentCachet = null;
        } 
      },
      // 签章移动开始
      doCachetStart: function() {
        this.cachetMove = true;
      },
    },
  };
</script>
<style lang="less" scoped>
.close-sty{
  cursor: pointer;
  float: right;
}
// 个人签字显示大小（参照发起页面显示的章大小）
.person-chap{
  width: 115px;
  height: 79px;
}
// 企业印章显示大小（参照发起页面显示的章大小）
.ent-chap{
  width: 208px;
  height: 208px;
}
.defalut-chap{
  width: 110px;
  height: 85px;
}
  .copy-sty{
    background: #f4ffb8 !important;
    border: 1px solid #7cb305 !important;
  }
  .btns-sty{
      display: flex;
      .btn:first-child{
        border-right: 1px solid #d9d9d9;
      }
      .btn {
        cursor: pointer;
        text-decoration: none;
        width: 100%;
        height: 29px;
        line-height: 29px;
        background: #f8f8f8;
        opacity: 1;
        border-radius: 0px 0px 2px 2px;
        text-align: center;
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #290202;
        display: block;
        margin-top: 16px;
      }
  }
  .var-setting{
    margin:15px 0 5px 0;
  }
  .signature-wrap {
    position: absolute;
    z-index: 10;
    outline: none;
    cursor: move;

    &:focus {
      outline: none;
    }

    &.is-draging {
      z-index: 30;
    }

    &.fixed {
      cursor: default !important;
    }

    .del-chapter {
      font-size: 18px;
      color: #a1a1a1;
      top: -9px;
      right: -10px;
      z-index: 12;
      position: absolute;
    }
  }

  // 新版样式
  .qz-new{
    // width: 110px;
    opacity: 1;
    // position: relative;
    border:1px solid rgba(236,28,28,1);
    border-style: none dashed dashed dashed;
    box-sizing: border-box;
    border-radius:0 0 10px 10px;
    background: #FFFFFF;
    h1{
      height: 25px;
      background: #ffa7a7;
      font-size:12px;
      font-family:PingFang SC;
      font-weight:400;
      line-height:25px;
      color:rgba(255,255,255,1);
      padding-left: 5px;
      box-sizing: border-box;
      border-radius:6px 6px 0px 0px;
      text-align: left;
      transition: all ease 0.2s;
    }
    .batch-settings{
      display: none;
    }
    &:hover{
      .batch-settings{
        display: inline-block;
        position: absolute;
        top: 57px;
        right: 5px;
      }
    }
    .con{
      transition: all ease 0.2s;
      opacity: 0.7;
      font-size: 12px;
      text-align: center;
      position: relative;
      // height:85px;
      padding:18px 5px;
      text-overflow: ellipsis;
    }
    img{
      position: absolute;
      width: 15px;
      height: 15px;
      left:50%;
      bottom:-8px;
      margin-left:-8px;
    }
    .del-chapter{
      position: absolute;
      top:-9px;
      right:-10px;
      color: #a1a1a1;
      z-index: 54;
    }

    .time{
      position: absolute;
      left: 4px;
      bottom: 2px;
      z-index: 2;
      font-size: 10px;
      color:rgba(236,28,28,1);
    }

    &.draging{
      /*opacity: 0.7;*/
      position: relative;
      z-index: 80;
      h1{
        background:rgba(236,28,28,1);
      }

      .con{
        opacity: 1;
      }
    }
  }


  .is-draging {
    /*border: 1px dashed #EC1C1C;*/
    /*padding: 10px 20px;*/
    /*margin-left: -10px;*/
    /*margin-top: -20px;*/

    &:after {
      position: absolute;
      top: -10px;
      bottom: -10px;
      right: -20px;
      left: -20px;
      /*padding: 10px 20px;*/
      content: " ";
      border: 1px dashed #EC1C1C;
      border-radius: 2px;
    }

    .del-chapter {
      top: -19px;
      right: -30px;
    }

    .move {
      position: absolute;
      width: 15px;
      height: 15px;
      left: -28px;
      top: 50%;
      margin-top: -8px;
    }
  }
</style>



// WEBPACK FOOTER //
// components/advancedVersion/signature.vue